import { config } from '../../config/buyout';
import { MUTATION_TYPES } from './_mutation-types';
import _set from 'lodash/set';

export const mutations = {
	[MUTATION_TYPES.SET_CAMPAIGN_IDENTIFIER](state, val) {
		state.campaignIdentifier = val;
	},
	[MUTATION_TYPES.SET_CAMPAIGN](state, val) {
		state.campaign = val;
	},
	[MUTATION_TYPES.SET_CATEGORIES](state, val) {
		state.categories = val;
	},
	[MUTATION_TYPES.SET_BRANDS](state, val) {
		state.brands = val;
	},
	[MUTATION_TYPES.SET_MODELS](state, val) {
		state.models = val;
	},
	[MUTATION_TYPES.SET_COLORS](state, val) {
		state.colors = val;
	},
	[MUTATION_TYPES.RESET_CATEGORIES](state) {
		state.categories = [];
		state.selectedCategory = null;
	},
	[MUTATION_TYPES.RESET_BRANDS](state) {
		state.brands = [];
		state.selectedBrand = null;
	},
	[MUTATION_TYPES.RESET_MODELS](state) {
		state.models = [];
		state.selectedModel = null;
	},
	[MUTATION_TYPES.RESET_COLORS](state) {
		state.colors = [];
		state.selectedColor = null;
	},
	[MUTATION_TYPES.SET_SELECTED_CATEGORY](state, val) {
		state.selectedCategory = val;
	},
	[MUTATION_TYPES.SET_SELECTED_BRAND](state, val) {
		state.selectedBrand = val;
	},
	[MUTATION_TYPES.SET_SELECTED_MODEL](state, val) {
		state.selectedModel = val;
	},
	[MUTATION_TYPES.SET_SELECTED_COLOR](state, val) {
		state.selectedColor = val;
	},
	[MUTATION_TYPES.SET_SELECTED_CATEGORY_BY_SEO_NAME](state, val) {
		state.selectedCategory = state.categories.find(
			item => item.seo_name === val
		);
	},
	[MUTATION_TYPES.SET_SELECTED_BRAND_BY_SEO_BANE](state, val) {
		state.selectedBrand = state.brands.find(item => item.seo_name === val);
	},
	[MUTATION_TYPES.SET_SELECTED_MODEL_BY_SEO_NAME](state, val) {
		state.selectedModel = state.models.find(item => item.seo_name === val);
	},
	[MUTATION_TYPES.SET_SELECTED_COLOR_BY_SEO_NAME](state, val) {
		state.selectedColor = state.colors.find(item => item.seo_name === val);
	},
	[MUTATION_TYPES.SET_LOADING_CATEGORIES](state, val) {
		state.loadingCategories = val;
	},
	[MUTATION_TYPES.SET_LOADING_BRANDS](state, val) {
		state.loadingBrands = val;
	},
	[MUTATION_TYPES.SET_LOADING_MODELS](state, val) {
		state.loadingModels = val;
	},
	[MUTATION_TYPES.SET_LOADING_COLORS](state, val) {
		state.loadingColors = val;
	},
	[MUTATION_TYPES.SET_GENDERS](state, val) {
		state.genders = val;
	},
	[MUTATION_TYPES.SET_STATES](state, val) {
		if (config.swap_first_country) [val[0], val[1]] = [val[1], val[0]];
		if (state.isRegistration)
			state.contractForm.customer_data.country_identifier = val[0].identifier;
			if (config.country_as_nationality) state.contractForm.customer_data.nationality = val[0].identifier;
		state.states = val;
	},
	[MUTATION_TYPES.SET_CONTRACT_FORM](state, val) {
		state.contractForm = val;
	},
	[MUTATION_TYPES.SET_FORM_FIELD](state, val) {
		_set(state.contractForm, val.key, val.value);
	},
	[MUTATION_TYPES.SET_QUALITIES](state, val) {
		state.qualities = val;
	},
	[MUTATION_TYPES.SET_QUALITY_TYPES](state, val) {
		state.qualityTypes = val;
	},
	[MUTATION_TYPES.SET_SELECTED_QUALITY](state, val) {
		state.selectedQuality = val;
		if (val && state.buyoutBonuses && state.buyoutBonuses.length) {
			state.selectedBonus = state.buyoutBonuses.find(
				bonus => bonus.quality_name === val.quality
			);
		}
	},
	[MUTATION_TYPES.SET_APPRAISAL](state, val) {
		state.appraisal = val;
	},
	[MUTATION_TYPES.SET_USER_BUYOUT_CODE](state, val) {
		state.userBuyoutCode = val;
	},
	[MUTATION_TYPES.SET_CANNOT_BE_BUYOUT](state, val) {
		state.canNotBeBuyout = val;
	},
	[MUTATION_TYPES.SET_DISPLAY_THANK_YOU](state, val) {
		state.displayThankYou = val;
	},
	[MUTATION_TYPES.SET_IS_APPRAISAL_EDITABLE](state, val) {
		state.isAppraisalEditable = val;
	},
	[MUTATION_TYPES.SET_APPRAISAL_ERRORS](state, val) {
		state.appraisalErrors = val;
	},
	[MUTATION_TYPES.SET_APPRAISAL_LOAD_ERROR](state, val) {
		state.appraisalLoadError = val;
	},
	[MUTATION_TYPES.SET_DEFAULT_QUALITY_CONDITIONS](state, val) {
		state.defaultQualityConditions = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_BONUSES](state, val) {
		state.buyoutBonuses = val;
	},
	[MUTATION_TYPES.SET_IS_PRE_SALE_INFO](state, val) {
		state.isPreSaleInfo = val;
	},
	[MUTATION_TYPES.SET_IS_BUYOUT_ONLINE](state, val) {
		state.isBuyoutOnline = val;
	},
	[MUTATION_TYPES.SET_PRE_SALE_INFO_EMAIL](state, val) {
		state.preSaleInfoEmail = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_LOAD_ERROR](state, val) {
		state.buyoutLoadError = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_STATE](state, val) {
		state.buyoutState = val;
	},
	[MUTATION_TYPES.SET_IS_REGISTRATION](state, val) {
		state.isRegistration = val;
	},
	[MUTATION_TYPES.SET_SELECTED_BONUS](state, val) {
		state.selectedBonus = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_RECEIPT](state, val) {
		state.buyoutReceipt = val;
	},
	[MUTATION_TYPES.SET_IS_REGISTRATION](state, val) {
		state.isRegistration = val;
	},
	[MUTATION_TYPES.SET_IS_LOGGED_IN](state, val) {
		state.isLoggedIn = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_RECEIPT](state, val) {
		state.buyoutReceipt = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_RECEIPT_ERRORS](state, val) {
		state.buyoutReceiptErrors = val;
	},
	[MUTATION_TYPES.SET_PICKUP_ADDRESS](state, val) {
		state.pickupAddress = val;
		state.pickupAddress.country_identifier =
			state.contractForm.customer_data.country_identifier;
	},
	[MUTATION_TYPES.SET_PICKUP_ADDRESS_ERRORS](state, val) {
		state.pickupAddressErrors = val;
	},
	[MUTATION_TYPES.SET_NEW_DEVICE_IMEI](state, val) {
		state.newDeviceImei = val;
	},
	[MUTATION_TYPES.SET_NEW_DEVICE_IMEI_ERRORS](state, val) {
		state.newDeviceImeiErrors = val;
	},
	[MUTATION_TYPES.SET_NEW_DEVICE_IMEI_SAVED](state, val) {
		state.newDeviceImeiSaved = val;
	},
	[MUTATION_TYPES.SET_EDITABLE_IMEI](state, val) {
		state.editableImei = val;
	},
	[MUTATION_TYPES.SET_DISABLE_BUYOUT_SEND_BTN](state, val) {
		state.disableBuyoutSendBtn = val;
	},
	[MUTATION_TYPES.SET_STATE_TYPES](state, val) {
		state.stateTypes = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_STATE_IDENTIFIER](state, val) {
		state.buyoutStateIdentifier = val;
	},
	[MUTATION_TYPES.SET_COMMON_ERROR](state, val) {
		state.commonError = val;
	},
	[MUTATION_TYPES.SET_PARTNERS](state, val) {
		state.partners = val;
	},
	[MUTATION_TYPES.SET_SELECTED_PARTNER](state, val) {
		state.selectedPartner = val;
	},
	[MUTATION_TYPES.SET_CONSENT_TO_MARKETING](state, val) {
		state.consentToMarketing = val;
	},
	[MUTATION_TYPES.SET_QUALITIES](state, val) {
		state.qualities = val;
	},
	[MUTATION_TYPES.SET_LOADING_APPRAISAL](state, val){
		state.loadingAppraisal = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_ADDITIONAL_INFO_BY_KEY](state, payload){
		const {key, value} = payload;
		state.buyoutAdditionalInfo[key] = value;
	},
	[MUTATION_TYPES.SET_BUYOUT_ADDITIONAL_INFO](state, val){
		state.buyoutAdditionalInfo = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_ADDITIONAL_INFO_ERRORS](state, val){
		state.buyoutAdditionalInfoErrors = val;
	},
	[MUTATION_TYPES.SET_BUYOUT_LOADING](state, val){
		state.buyoutLoading = val;
	},
	[MUTATION_TYPES.SET_DIFFERENT_PICKUP_ADDRESS](state, val) {
		_set(state.pickupAddress, val.key, val.value);
		state.pickupAddress.country_identifier =
			state.contractForm.customer_data.country_identifier;
	},
	[MUTATION_TYPES.SET_IS_DIFFERENT_PICKUP_ADDRESS](state, val){
		state.isDifferentPickupAddress = val;
	},
	[MUTATION_TYPES.SET_SELECTED_NEW_MODEL](state, val){
		state.selectedNewModel = val;
	},
	[MUTATION_TYPES.SET_SELECTED_NEW_MODEL_PARTNER](state, val){
		state.selectedNewModelPartner = val;
	},
}
